import { render, staticRenderFns } from "./TsPreviewPdf.vue?vue&type=template&id=24833fca&scoped=true&"
import script from "./TsPreviewPdf.vue?vue&type=script&lang=js&"
export * from "./TsPreviewPdf.vue?vue&type=script&lang=js&"
import style0 from "./TsPreviewPdf.vue?vue&type=style&index=0&id=24833fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24833fca",
  null
  
)

export default component.exports